module.exports = __webpack_public_path__ + "/images/logo-app-google.34f4a82.svg";